import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SmartConnectorStatus } from '../types';
import { getSmartConnectorStatusesConfig } from '../helpers';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

const NO_VALUE = '—';

export const StatusText: FC<{ status: SmartConnectorStatus }> = ({
  status,
}) => {
  const { t } = useTranslation();
  const { label = NO_VALUE, color = null } = useMemo(
    () => getSmartConnectorStatusesConfig(t)[status] || {},
    [t, status]
  );

  return (
    <TextEllipsisWithTooltip color={color}>{label}</TextEllipsisWithTooltip>
  );
};
